import {
  ANALYTICS_ROUTE,
  INVENTORY_ROUTE,
  KIOSK_HOME_ROUTE,
  MARKETING_ROUTE,
  ROUTE_CONSTANTS_MAP,
  SERVICE_ROUTE,
  SUPPORT_ROUTE,
} from "../../../utils/routeConstants";
import { KIOSK_ENTRY_ENABLED } from "../../../kiosk/featureFlag";

export * from "./shared";

/**
 * WEB variant — verbatim from `apps/web/src/commonComponents/LeftMenu/menuItemsData.ts`.
 * Values are browser PATHS. See `./shared.ts`.
 *
 * The `any` is the app's own annotation, kept so `LICENSE_LANDING_ROUTE[code]` still indexes
 * with an arbitrary string (callers pass `response.assignedLicence` straight from the API).
 */
export const LICENSE_LANDING_ROUTE: any = {
  INV: INVENTORY_ROUTE,
  MKT: MARKETING_ROUTE,
  ALT: ANALYTICS_ROUTE,
  SEP: ROUTE_CONSTANTS_MAP.NEW_ORDER_ROUTE,
  SLT: ROUTE_CONSTANTS_MAP.NEW_ORDER_ROUTE,
  SLF: ROUTE_CONSTANTS_MAP.NEW_ORDER_ROUTE,
  SOL: ROUTE_CONSTANTS_MAP.NEW_ORDER_ROUTE,
  POO: ROUTE_CONSTANTS_MAP.NEW_ORDER_ROUTE,
  SPT: SUPPORT_ROUTE,
  POS: SERVICE_ROUTE,
  RHP: ROUTE_CONSTANTS_MAP.NEW_ORDER_ROUTE,
  // The kiosk's Home page, not the kiosk itself — a login must not put a device straight
  // into customer-facing kiosk mode. Only with the kiosk switched on (R7a, 2026-10-15).
  ...(KIOSK_ENTRY_ENABLED ? { KSK: KIOSK_HOME_ROUTE } : {}),
};
